// extracted by mini-css-extract-plugin
module.exports = {"mainLogo":"bigLogo-module--mainLogo--51ILE","iconedLinkes":"bigLogo-module--iconedLinkes--2Lvay"};